<!-- layout admin -->
<div *ngxPermissionsOnly="['ADMIN', 'ACCOUNTANT', 'STORE', 'SALE_1', 'SALE_2', 'NUTRISHOP_1']">
  <div class="flex h-[100vh] w-[100vw]">
    <!-- sidenav-main -->
    <div class="sidebar overflow-hidden shadow-xl z-10" [ngClass]="{'w-[18rem]':isOpen, 'w-[0rem]': !isOpen}">
      <!-- logo -->
      <div class=" h-16 px-2 flex flex-row items-center justify-between bg-gray-500 ">
        <!-- logo-img -->
        <div class="flex items-center gap-1 overflow-hidden" *ngIf="isOpen">
          <img class="h-12" src="assets/images/logo.jpg" alt="" />
          <span class="text-white text-3xl font-bold text-ellipsis whitespace-nowrap font-['Lobster']">Nutri day</span>
        </div>
      </div>
      <!-- nav-item-container -->
      <div class="overflow-y-auto h-[calc(100vh-4rem)]">
        <!-- nav-item -->
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="whitespace-nowrap">
          <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="'2rem'">
            <button class="text-base whitespace-nowrap" mat-button *ngIf="node.type, else router"
              style="font-weight: 400;" class="w-full !justify-start" (click)="onNodeClick(node)">
              <span>{{node.name}}</span>
            </button>
            <ng-template #router>
              <a [routerLink]="[node.link]" mat-button class="w-full !justify-start text-ellipsis text-base mx-1"
                matTooltip="{{node.name}}" matTooltipPosition="right" style="font-weight: 400;">
                {{node.name}}
              </a>
            </ng-template>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <button class="mx-1 text-base whitespace-nowrap w-full !justify-start" mat-button matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror" *ngIf="isOpen">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
              {{node.name}}
            </button>
          </mat-tree-node>
        </mat-tree>
      </div>
    </div>
    <div class="page" [style.width]=" isOpen ? 'calc(100vw - 18rem)': 'calc(100vw)'">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
</div>

<!-- layout user -->
<ng-template [ngxPermissionsExcept]="['ADMIN', 'ACCOUNTANT', 'STORE', 'SALE_1', 'SALE_2', 'NUTRISHOP_1']">
  <div class="page">
    <!-- <div class="page w-[100vw]"> -->
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>